import { colors, Table, Toggle } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';

export const SectionWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 2rem 0 5rem;
  margin: 0 auto 16rem;
`;

export const TableTitleStyled = styled.h3`
  font-size: 2.4rem;
  line-height: 3.2rem;
  text-align: center;
  margin: 2rem 0;
`;

export const ErrorsToggleStyled = styled(Toggle)`
  margin-left: 4rem;
  margin-bottom: 2rem;
`;

export const TableWrapperStyled = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const TableStyled = styled(Table)<{ $columnsAmount: number }>`
  width: max(100%, ${({ $columnsAmount }): CSSProp => $columnsAmount * 16}rem);
  border: 0.05rem solid ${colors.neutral[300]};
`;
